import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'business.name',
      label: i18n.t('common_words.company'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 160,
      sortable: true,
    },
    {
      prop: 'scale.name',
      label: i18n.t('devices.tablet'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'tablet_mac',
      label: 'MAC tablet',
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'indicator_code',
      label: i18n.t('devices.indicator_code'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'serial_number',
      label: i18n.t('devices.serial_number'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'alias',
      label: i18n.t('common_words.alias'),
      minWidth: 130,
      show: false,
    },
    {
      prop: 'brand',
      label: i18n.t('devices.brand'),
      minWidth: 130,
      show: false,
    },
    {
      prop: 'device_version',
      label: i18n.t('common_words.device_version'),
      minWidth: 130,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'sync_time',
      label: i18n.t('common_words.synchronization_time'),
      minWidth: 160,
      align: 'center',
      show: false,
    },
    {
      prop: 'user',
      label: i18n.t('common_words.user'),
      minWidth: 120,
      sortable: true,
      formatter: (row) => {
        return  `${row.user.first_name} ${row.user.last_name}`;
      },
    },
    {
      prop: 'unit_tara_weight',
      label: i18n.t('production.fruit_weight_unit'),
      show: false,
    },
    {
      prop: 'weight_threshold_min',
      label: i18n.t('common_words.weight_threshold_min'),
      show: false,
    },
    {
      prop: 'weight_threshold_max',
      label: i18n.t('common_words.weight_threshold_max'),
      show: false,
    },
    {
      prop: 'lb_to_kg_factor',
      label: 'Tara de báscula',
      show: false,
    },
  ];

  return { tableColumns };
};

export default configTable;
